import { AuthStrategy } from "@/lib/auth-strategy";
import { LogLevel } from "@/lib/logger";
import type { PrimaryColor } from "@/styles/theme/types";

export interface AppConfig {
    name: string;
    description: string;
    // Overriden by Settings Context.
    direction: "ltr" | "rtl";
    // Overriden by Settings Context.
    language: string;
    // Overriden by Settings Context.
    theme: "light" | "dark" | "system";
    themeColor: string;
    // Overriden by Settings Context.
    primaryColor: PrimaryColor;
    logLevel: keyof typeof LogLevel;
    authStrategy: keyof typeof AuthStrategy;

    backendUrl?: string;
}

export const appConfig: AppConfig = {
    name: "SCADA-Automation Cloud",
    description: "",
    direction: "ltr",
    language: "de",
    theme: "light",
    themeColor: "#090a0b",
    //primaryColor: "neonBlue",
    primaryColor: "scadaBlue",
    logLevel: (import.meta.env.VITE_LOG_LEVEL as keyof typeof LogLevel) || LogLevel.ALL,
    authStrategy: (import.meta.env.VITE_AUTH_STRATEGY as keyof typeof AuthStrategy) || AuthStrategy.NONE,


    backendUrl: (import.meta.env.VITE_BACKEND_URL),
};
